<div class="searchbar border-grey-1 bg-color-white" id="barra-pesquisa" aria-label="pesquisarEmCursos" role="searchbox">
  <form [formGroup]="formularioPesquisa" (ngSubmit)="onPesquisar()">
    <div class="input-container" role="none">
      <input type="search" class="input color-dark bg-color-white" id="busca-{{ componenteAtual }}"
        placeholder="Termo de busca" name="StringBusca" [value]="searchString" formControlName="stringBusca"
        aria-label="digiteoTextoDaSuaPesquisa" />
      <button type="submit" value="buscar no catálogo" class="search-button">
        buscar no catálogo
      </button>
      <span role="separator" class="vert-line" *ngIf="eixos"></span>
      <button type="button" class="filters-btn cursor-pointer" (click)="toggle = !toggle" *ngIf="eixos">
        filtros <span role="img" class="filter-toggle"></span>
      </button>
    </div>
    <hr class="bg-color-dark-grey hr-line" *ngIf="toggle && eixos" />
    <div class="filters" [ngClass]="{ open: toggle && eixos }">
      <div class="wrap" role="none">
        <ul class="filter">
          <p class="filter-title">Ordenar por</p>
          <p class="filter-group" *ngFor="let ordenacao of ordenarPor">
            <label class="filter-label"><input type="radio" name="ordenacao" id="{{ ordenacao.nome | normalize }}"
                class="filter-input" formControlName="ordenacao" [value]="ordenacao.id" />{{ ordenacao.nome }}</label>
          </p>
        </ul>
        <ul class="filter">
          <p class="filter-title">Filtrar por</p>
          <p class="filter-group" *ngFor="let filtro of filtrarPor">
            <label class="filter-label"><input type="radio" name="filtro" id="{{ filtro.nome | normalize }}"
                class="filter-input" formControlName="filtro" [value]="filtro.id" />{{ filtro.nome }}</label>
          </p>
        </ul>
      </div>

      <ul class="filter">
        <p class="filter-title">Eixos Tecnológicos</p>
        <div class="wrap-column">
          <li class="filter-group" *ngFor="let eixo of eixos">
            <label class="filter-label"><input type="radio" name="eixo" id="{{ eixo.nome | normalize }}"
                class="filter-input" [value]="eixo.id" formControlName="eixo" />{{ eixo.nome }}</label>
          </li>
        </div>
      </ul>

      <button type="submit" class="btn btn-md btn-dark rounded-pill cursor-pointer">
        Aplicar filtro
      </button>
    </div>
  </form>
</div>